import { Redirect, useLocalSearchParams } from 'expo-router';
import { useAtomValue } from 'jotai';
import * as React from 'react';
import { Spinner } from 'smoothie';

import { IncomeSplitReview } from '../../../banking/components/income-split/IncomeSplitReview';
import { IncomeSplitReviewNew } from '../../../banking/components/income-split/IncomeSplitReviewNew';
import { useInternalInvestmentAccountsForIncomeSplit } from '../../../banking/hooks/income-split/useInternalInvestmentAccountsForIncomeSplit';
import useShouldSeeTiedRules from '../../../banking/hooks/income-split/useShouldSeeRuleSets';
import {
    incomeSplitAtom,
    incomeSplitAtomLegacy,
} from '../../../banking/state/PaycheckRoutingAtoms';
import { bankAccountDisplayDetails } from '../../../banking/state/SpacesAtoms';

export default function IncomeSplitReviewScreen() {
    const incomeSplit = useAtomValue(incomeSplitAtomLegacy);
    const incomeSplitNew = useAtomValue(incomeSplitAtom);
    const bankAccountDetails = useAtomValue(bankAccountDisplayDetails);

    const {
        internalInvestmentAccounts,
        isLoading: isLoadingInternalInvestmentAccounts,
    } = useInternalInvestmentAccountsForIncomeSplit();

    const { tiedRules } = useLocalSearchParams<{
        tiedRules: string;
    }>();

    const enableTiedRules = useShouldSeeTiedRules();

    if (tiedRules !== 'true' && !incomeSplit) {
        return <Redirect href="/home/banking" />;
    }

    if (tiedRules === 'true' && enableTiedRules) {
        if (!incomeSplitNew) {
            return <Redirect href="/home/banking" />;
        }
        if (isLoadingInternalInvestmentAccounts) {
            return <Spinner />;
        }
        return (
            <IncomeSplitReviewNew
                incomeSplit={incomeSplitNew}
                bankAccountDetails={bankAccountDetails}
                internalInvestmentAccounts={internalInvestmentAccounts}
                context="incomeSplit"
            />
        );
    }
    return (
        <IncomeSplitReview
            incomeSplit={incomeSplit}
            bankAccountDetails={bankAccountDetails}
            context="incomeSplit"
        />
    );
}
